import { useRef, useEffect, useState } from 'react';
import { ANNOTATION_FONT_SIZE } from 'constants/feature/annotation-elements-constants';
/** Taken from the React hooks docs https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 * Lets you store the previous value of a prop or local state variable in a functional component to mimic componentDidUpdate(prevState, prevProps)
 */
export const usePrevious = (value) => {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
};

export const useAnnotationFontSize = (
  statementId,
  setAnnotationsDisplayFontSize,
) => {
  const [
    annotationDisplayFontSizeLocalState,
    setAnnotationsDisplayFontSizeLocalState,
  ] = useState({
    annotationFontSize: ANNOTATION_FONT_SIZE[3],
    fontSize: ANNOTATION_FONT_SIZE[3].value, // default font-size
  });

  useEffect(() => {
    const storedFontSizes =
      JSON.parse(localStorage.getItem('annotationFontSizeStatementWise')) || [];

    const fontSizeEntry = storedFontSizes.find(
      (item) => item.statementId === statementId,
    );

    const fontSize = fontSizeEntry ? fontSizeEntry.fontSize : undefined;

    if (fontSize) {
      setAnnotationsDisplayFontSize({ fontSize });
      setAnnotationsDisplayFontSizeLocalState({
        annotationFontSize: fontSize,
        fontSize: fontSize.id,
      });
    }
  }, [statementId, setAnnotationsDisplayFontSize]);

  const selectAnnotationPosition = (fontSize) => {
    const storedFontSizes =
      JSON.parse(localStorage.getItem('annotationFontSizeStatementWise')) || [];

    const existingIndex = storedFontSizes.findIndex(
      (item) => item.statementId === statementId,
    );

    if (existingIndex !== -1) {
      storedFontSizes[existingIndex].fontSize = fontSize;
    } else {
      storedFontSizes.push({ statementId: statementId, fontSize });
    }

    localStorage.setItem(
      'annotationFontSizeStatementWise',
      JSON.stringify(storedFontSizes),
    );

    setAnnotationsDisplayFontSize({ fontSize });
    setAnnotationsDisplayFontSizeLocalState({
      annotationFontSize: fontSize,
      fontSize: fontSize.id,
    });
  };

  return {
    annotationDisplayFontSize: annotationDisplayFontSizeLocalState,
    selectAnnotationPosition,
  };
};
